import React from 'react'
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, 
  AccumulationSeriesDirective, Inject, AccumulationDataLabel, 
  AccumulationTooltip, PieSeries } from '@syncfusion/ej2-react-charts';

import { pieChartData } from '../../data/dummy'
// import { useStateContext } from '../../contexts/ContextProvider';
import { ChartsHeader , Pie as PieChart } from '../../components';



const Pie = () => {

  // const { currentMode} = useStateContext()

  return (
    <div className="m-4 md:m-10 mt-24  p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl">
    
    <ChartsHeader category="Pie" title="Project Cost Breakdown "/>
   
    <div className="w-full">
      <PieChart  
          id= 'chart-pie'           
          data={pieChartData}
          legendVisibility
          height='full' 
      />
      
    </div>

  </div>
  )
}

export default Pie